// utils/googleDriveUtils.js

export const extractGoogleDriveID = (GoogleDriveLink) => {
  if (typeof GoogleDriveLink !== 'string') {
    console.warn('Invalid GoogleDriveLink passed:', GoogleDriveLink);
    return null;
  }

  const cleanedLink = GoogleDriveLink
    .replace('/view?usp=sharing', '/view')
    .replace('?usp=sharing', '');

  const match = cleanedLink.match(/\/d\/([a-zA-Z0-9_-]+)/);
  return match ? match[1] : null;
};
